import { render, staticRenderFns } from "./RSSuggestionsList.vue?vue&type=template&id=5f4800f6&scoped=true&"
import script from "./RSSuggestionsList.vue?vue&type=script&lang=js&"
export * from "./RSSuggestionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4800f6",
  null
  
)

export default component.exports